// Copyright (c) 2019 Deere & Company

import './index.scss';
import LabeledInput from '../../../shared/components/labeled-input';
import OptionsDropdown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import React from 'react';

const handleNameChange = props => event => {

    props.onTextChange( props, event );

};

const handleBMCNameOnChange = props => event => {

    props.handleBMCNameOnChange( event.target.value );

};

function handleDeleteClick ( mode, obj ) {

    this.handleDeleteClick( mode, obj );

}
const WPSMAside = props => (
    <section>
        {!props.isEdit && (
            <div className="addnew-section">
                <p>Select Base Code to Edit</p>
                <p> Or</p>
                <button className="primary-button" type="button" onClick={props.handleBaseCodeAddClick}> Add New BMC </button>
            </div>
        )}

        {( props.editMode === 'BASECODE' && props.isEdit ) && (
            <div>
                <h4>BMC Details</h4>
                <div>
                    <LabeledInput
                        className="input-name"
                        isEditable={true}
                        disabled={true}
                        label="FactoryCode"
                        maxLength={15}
                        value={props.baseCode.factoryCode}
                    />
                </div>
                <div>
                    <OptionsDropdown
                        className="input-name"
                        isPlaceholderTranslated={true}
                        label="Product Series"
                        onChange={props.handleSeriesOnChange}
                        optionDisplayAttributes={['productSeriesName']}
                        optionKey="productSeriesId"
                        options={props.productserieslist}
                        placeholder="Select Product Series"
                        selectedValue={props.baseCode.productSeriesId}
                        isRequired={true}
                    />
                </div>
                <div>
                    <OptionsDropdown
                        className="input-name"
                        isPlaceholderTranslated={true}
                        label="Product Sub Series"
                        onChange={props.handleSubSeriesOnChange}
                        optionDisplayAttributes={['productSubSeriesName']}
                        optionKey="productSubSeriesId"
                        options={props.productSubSeriesList}
                        placeholder="Select Product Sub Series"
                        selectedValue={props.baseCode.productSubSeriesId}
                        isRequired={true}
                    />
                </div>
                <div>
                    <LabeledInput
                        className="input-name"
                        isEditable={props.id === -1}
                        label="BMC Name"
                        maxLength={15}
                        onChange={handleBMCNameOnChange( props )}
                        value={props.baseCode.baseCodeName}
                        isRequired={true}
                    />
                </div>
                {( props.isEdit && props.editMode === 'BASECODE' && props.baseCode.baseCodeId ) && (
                    <div className="button-align">
                        <button type="button" onClick={handleDeleteClick.bind( props, props.mode, props.baseCode )}>
                            <span> Delete </span>
                        </button>
                        <button className="primary-button" type="button" onClick={props.onUpdate}>
                            <span> Update </span>
                        </button>
                    </div>
                )}
                {( props.isEdit && props.editMode === 'BASECODE' && !props.baseCode.baseCodeId ) && (
                    <div className="button-align">
                        <button className="close-button" type="button" onClick={props.onCancel}>
                            <span> Cancel </span>
                        </button>
                        <button
                            className="primary-button"
                            type="button"
                            onClick={props.onUpdate}
                            disabled={!(
                                ( props.baseCode.productSeriesId !== undefined && props.baseCode.productSeriesId !== '-1' )
                                && ( props.baseCode.productSubSeriesId !== undefined && props.baseCode.productSubSeriesId !== '-1' )
                                && ( props.baseCode.baseCodeName !== undefined && ( props.baseCode.baseCodeName ).trim() !== '' ) )
                            }
                        >
                            <span> Add </span>
                        </button>
                    </div>
                )}
            </div>
        )}

        {( props.isEdit && props.editMode !== 'BASECODE' ) && (
            <div>
                <header>
                    {props.id === -1 ? 'Add' : 'Edit'}
                    {props.editMode === 'SERIES' ? ' Product Series' : ' Product Sub Series'}
                </header>
                <div>
                    <LabeledInput
                        className="input-name"
                        isEditable={true}
                        label="NAME"
                        maxLength={props.editMode === 'SERIES' ? 30 : 30}
                        onChange={handleNameChange( props )}
                        value={props.value}
                        isRequired={true}
                    />
                </div>
                <div className="button-align">
                    <button className="close-button" type="button" onClick={props.onCancel}>
                        <span> Cancel </span>
                    </button>
                    <button className="primary-button" type="button" onClick={props.onUpdate} disabled={( props.value ).trim() === ''}>
                        <span> Update </span>
                    </button>
                </div>
            </div>
        )}
    </section>
);
WPSMAside.displayName = 'WPSMAside';
WPSMAside.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    baseCode: PropTypes.object.isRequired,
    editMode: PropTypes.string,
    mode: PropTypes.string,
    productSubSeriesList: PropTypes.array,
    productserieslist: PropTypes.array,
    onUpdate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    handleBaseCodeAddClick: PropTypes.func.isRequired,
    handleSeriesOnChange: PropTypes.func.isRequired,
    handleSubSeriesOnChange: PropTypes.func.isRequired,
};
export default WPSMAside;
